import passmac from "../../../../assets/images/docs/1password/macos.png";
import * as React from 'react';
export default {
  passmac,
  React
};